module.exports = __webpack_public_path__ + "static/img/game6.88732758.png";